import React, { useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { BRACELL_DANO_SEVERIDADE } from "../../config/bracellRegistryProfile";
import style from "./bracell-row-extras.module.css";

function clampPct(n) {
  if (!Number.isFinite(n)) return 0;
  return Math.min(100, Math.max(0, Math.round(n)));
}

/**
 * Campos extras BRACELL por planta: incidência 0–100 (+/−1) e dano_severidade.
 * Linha de incidência usa o mesmo layout que "Nº de insetos (planta)" (beetle-lague.module.css).
 */
function BracellRowExtras({
  desfolha_incidencia_percent = "0",
  dano_severidade = "Sem Dano",
  onPatch,
}) {
  const pct = clampPct(Number(String(desfolha_incidencia_percent).replace(",", ".")));

  const setPct = useCallback(
    (next) => {
      onPatch({
        desfolha_incidencia_percent: String(clampPct(next)),
      });
    },
    [onPatch]
  );

  const bump = useCallback(
    (delta) => {
      setPct(pct + delta);
    },
    [pct, setPct]
  );

  return (
    <div className={style.wrap}>
      <div className={style.informationUnsheet}>
        <div className={style.fieldName}>Incidência desfolha (%)</div>
        <div className={style.contianerInput}>
          <RemoveIcon
            onClick={() => bump(-1)}
            className={style.icon}
          />
          <input
            className={style.input}
            type="number"
            min={0}
            max={100}
            value={pct}
            onChange={(e) => setPct(Number(e.target.value))}
          />
          <AddIcon
            onClick={() => bump(1)}
            className={style.icon}
          />
        </div>
      </div>
      <div className={style.informationUnsheet}>
        <div className={style.fieldName}>Dano / severidade</div>
        <div className={style.contianerInput}>
          <select
            className={style.selectDano}
            value={dano_severidade}
            onChange={(e) => onPatch({ dano_severidade: e.target.value })}
          >
            {BRACELL_DANO_SEVERIDADE.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default BracellRowExtras;
